import React, { Component, useContext, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import GridContainer from '../../../@jumbo/components/GridContainer';
import TextField from '@material-ui/core/TextField';
import IntlMessages from '../../../@jumbo/utils/IntlMessages';
import { connect, useDispatch } from 'react-redux';
import Button from '@material-ui/core/Button';
import { Box, fade } from '@material-ui/core';
import ContentLoader from '../../../@jumbo/components/ContentLoader';
import makeStyles from '@material-ui/core/styles/makeStyles';
import CmtImage from '../../../@coremat/CmtImage';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { NavLink } from 'react-router-dom';
import { DatePicker, KeyboardTimePicker, KeyboardDatePicker } from '@material-ui/pickers';
import { THEME_TYPES } from '../../../@jumbo/constants/ThemeOptions';
import AppContext from '../../../@jumbo/components/contextProvider/AppContextProvider/AppContext';
import { withStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import axios from 'axios';
import Alert from '@material-ui/lab/Alert';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import LanguageSwitcher from './LanguageSwitcher';
import InputLabel from '@material-ui/core/InputLabel';
import CircularProgress from '@material-ui/core/CircularProgress';
import { countriesHR, countriesEN } from '../../../@jumbo/constants/AppConstants';

const bgImage = '/images/auth/auth-bg-pattern.png';
const useStyles2 = makeStyles(theme => ({
  authWrap: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    /*backgroundImage: props => (props.variant === 'bgColor' ? `URL(${bgImage})` : ''),
    backgroundPosition: props => (props.variant === 'bgColor' ? 'center center' : ''),
    backgroundRepeat: props => (props.variant === 'bgColor' ? 'no-repeat' : ''),
    backgroundSize: props => (props.variant === 'bgColor' ? 'cover' : ''),*/
    backgroundColor: props => props.bgColor,
    position: 'relative',
    padding: 20,
    [theme.breakpoints.up('sm')]: {
      padding: 40,
    },
    '&:before': {
      content: '""',
      position: 'absolute',
      left: 0,
      top: 0,
      zIndex: 1,
      width: '100%',
      height: '100%',
      //      backgroundColor: props => (props.variant === 'bgColor' ? fade(theme.palette.primary.main, 0.5) : ''),
    },
  },
  boxClass2: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& > *': {
      marginBottom: theme.spacing(1),
    },
  },
  authCard: {
    position: 'relative',
    zIndex: 3,
    maxWidth: props => (props.variant === 'default' ? '850px' : '550px'),
    width: '100%',
    boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.14), 0px 3px 1px rgba(0, 0, 0, 0.12), 0px 1px 5px rgba(0, 0, 0, 0.2)',
    borderRadius: 4,
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.secondary,
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
    },
    [theme.breakpoints.up('xl')]: {
      maxWidth: props => (props.variant === 'default' ? '1050px' : '750px'),
    },
  },
}));

const AuthWrapper = ({ children, variant, bgColor }) => {
  var classes = useStyles2({ variant, bgColor });

  return (
    <Box className={classes.authWrap}>
      <Box className={classes.authCard}>{children}</Box>
    </Box>
  );
};

function getMyDate(prop) {
  var md = new Date(prop);
  var dd = String(md.getDate()).padStart(2, '0');
  var mm = String(md.getMonth() + 1).padStart(2, '0');
  var yyyy = md.getFullYear();
  return yyyy + '-' + mm + '-' + dd;
}

const useStyles = theme => ({
  circularProgressRoot: {
    position: 'absolute',
    left: 0,
    top: 0,
    zIndex: 1,
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  authThumb: {
    backgroundColor: fade(theme.palette.primary.main, 0.12),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '50%',
      order: 2,
    },
  },
  authContent: {
    padding: 30,
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: props => (props.variant === 'default' ? '50%' : '100%'),
      order: 1,
    },
    [theme.breakpoints.up('xl')]: {
      padding: 50,
    },
  },
  titleRoot: {
    marginBottom: 14,
    color: theme.palette.text.primary,
  },
  boxClass2: {
    display: 'flex',
    justifyContent: 'normal',
    alignItems: 'center',
    '& > *': {
      marginBottom: theme.spacing(1),
    },
  },

  titleRoot2: {},
  textFieldRoot: {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: fade(theme.palette.common.dark, 0.12),
    },
  },
  textFieldRoot2: {
    paddingLeft: 24,
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: fade(theme.palette.common.dark, 0.12),
    },
  },
  formcontrolLabelRoot: {
    '& .MuiFormControlLabel-label': {
      [theme.breakpoints.down('xs')]: {
        fontSize: 12,
      },
    },
  },
});

class SelfCheckIn extends Component {
  // We can use the `useParams` hook here to access
  // the dynamic pieces of the URL.
  constructor(props) {
    super(props);
    var x = '';
    if (this.props.match.params.bookingId != null) x = this.props.match.params.bookingId;
    var defaultSettings = {
      BackgroundColor: 'yellow',
      //'#2D7D9A',
    };
    this.state = {
      hotelId: this.props.match.params.hotelId,
      hotelCode: this.props.match.params.hotelCode,
      nrRooms: 0,
      loaded: false,
      rooms: [],
      nrGuests: 0,
      guestInfo: [],
      success: 0,
      message: '',
      allow: 1,
      myReservationId: '',
      reservationId: x,
      settings: defaultSettings,
    };

    /*const SelfCheckIn = ({ variant = 'default2', wrapperVariant = 'bgColor' }) => {
      const dispatch = useDispatch();
      const classes = useStyles({ variant });


      const onSubmit = () => {};*/

    this.onSubmit = this.onSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleAction = this.handleAction.bind(this);
  }

  onSubmit() {
    var pmsUrl = 'https://secure.webbookingpro.com/api/pass.php';
    if (this.state.hotelCode == 'wbp') pmsUrl = 'https://secure.webbookingpro.com/api/pms.php';

    if (this.state.myReservationId == '' && this.state.reservationId != '') {
      var x = this.state.reservationId;
      var y = [];
      const senddata = {
        Action: 'selfcheckin_getdata',
        HotelCode: this.state.hotelCode,
        Data: {
          HotelId: this.state.hotelId,
          ReservationId: this.state.reservationId,
        },
      };
      /*      var t = JSON.stringify(senddata);
      alert(t);*/
      var nrg = 0,
        nrr = 0,
        r = [];
      axios.post(pmsUrl, senddata).then(res => {
        if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
          localStorage.setItem('token', res.data.newToken);
        }
        if (res.data != null)
          if (res.data.Success == true) {
            var m = '',
              a = 1;
            if (res.data.message) {
              m = res.data.message;
              if (m != '') a = 0;
            }

            res.data.Data.forEach(function(item, index) {
              nrg += item.NrGuests;
              nrr += 1;
              r[nrr - 1] = item.RoomId;
              item.GuestsInfo.forEach(function(item2, index2) {
                item2.RoomId = item.RoomId;
                y.push(item2);
              });
            });
            if (y.length < nrg) {
              for (let i = 0; i < nrg; i++) {
                var gi = {
                  FirstName: '',
                  LastName: '',
                  Sex: 'M',
                  BirthDate: '1950-01-01',
                  BirthCountry: '',
                  idType: 1,
                  idNumber: '',
                  City: '',
                  Country: '',
                  Citizenship: '',
                };
                y.push(gi);
              }
            }
            this.setState({ rooms: r, myReservationId: x, nrGuests: nrg, nrRooms: nrr, guestInfo: y, message: m, allow: a });
          }
      });
    } else if (this.state.myReservationId != '') {
      const senddata = {
        Action: 'selfcheckin_senddata',
        HotelCode: this.state.hotelCode,
        Data: {
          HotelId: this.state.hotelId,
          Locale: this.context.locale.locale,
          ReservationId: this.state.myReservationId,
          GuestInfo: this.state.guestInfo,
        },
      };
      /*var t = JSON.stringify(senddata);
      alert(t);*/
      axios.post(pmsUrl, senddata).then(res => {
        if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
          localStorage.setItem('token', res.data.newToken);
        }
        if (res.data.Status == 0) {
          this.setState({ message: res.data.Message });
        }
        if (res.data.Status == 1) {
          this.setState({ message: '', success: 1 });
        }
      });
    }
  }

  handleAction(name, index) {
    if (name == 'changeId') {
      this.setState({ allow: 1, myReservationId: '', guestInfo: [] });
    }
    if (name == 'addnew') {
      var firstCity = this.state.guestInfo[0].City;
      if (firstCity == null) firstCity = '';
      var firstCountry = this.state.guestInfo[0].Country;
      if (firstCountry == null) firstCountry = '';
      var firstCitizenship = this.state.guestInfo[0].Citizenship;
      if (firstCitizenship == null) firstCitizenship = '';

      var gi = {
        FirstName: '',
        LastName: '',
        Sex: 'M',
        BirthDate: '1950-01-01',
        BirthCountry: '',
        idType: 1,
        idNumber: '',
        City: firstCity,
        RoomId: this.state.rooms[0],
        Country: firstCountry,
        Citizenship: firstCitizenship,
      };
      this.setState(prevState => {
        var rs = [...prevState.guestInfo];
        rs.push(gi);
        return { guestInfo: rs };
      });
    }
    if (name == 'delete') {
      this.setState(prevState => {
        var rs = [...prevState.guestInfo];
        rs.splice(index, 1);
        return { guestInfo: rs };
      });
    }
  }

  handleChange(name, value, index = -1) {
    if (value == null) return;
    if (index != -1) {
      this.setState(prevState => {
        const guestInfos = [...prevState.guestInfo];
        if (name == 'FirstName') guestInfos[index].FirstName = value;
        if (name == 'LastName') guestInfos[index].LastName = value;
        if (name == 'RoomId') guestInfos[index].RoomId = value;
        if (name == 'Sex') guestInfos[index].Sex = value;
        if (name == 'BirthDate') guestInfos[index].BirthDate = value;
        if (name == 'BirthCountry') guestInfos[index].BirthCountry = value;
        if (name == 'idType') guestInfos[index].idType = value;
        if (name == 'idNumber') guestInfos[index].idNumber = value;
        if (name == 'City') guestInfos[index].City = value;
        if (name == 'Country') guestInfos[index].Country = value;
        if (name == 'Citizenship') guestInfos[index].Citizenship = value;
        return { guestInfo: guestInfos };
      });
    } else
      this.setState({ [name]: value }, () => {
        //   this.updateRooms();
      });
  }
  componentDidMount() {
    //const senddata = { Action: 'getSelfCheckinSettings', HotelCode: this.state.hotelCode, HotelId: this.state.hotelId };

    const senddata = {
      Action: 'selfcheckin_getdata',
      HotelCode: this.state.hotelCode,
      Data: {
        HotelId: this.state.hotelId,
      },
    };
    var pmsUrl = 'https://secure.webbookingpro.com/api/pass.php';
    if (this.state.hotelCode == 'wbp') pmsUrl = 'https://secure.webbookingpro.com/api/pms.php';

    axios.post(pmsUrl, senddata).then(res => {
      if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
        localStorage.setItem('token', res.data.newToken);
      }
      if (res.data != null && res.data.Data != null) {
        this.setState({ settings: res.data.Data[0], loaded: true });
      }
    });
  }

  render() {
    const { classes } = this.props;
    countries = countriesHR;
    console.log(this.props.auth);
    console.log(this.context);
    var locale = this.context.locale.locale;
    if (locale != null) {
      if (locale == 'en') var countries = countriesEN;
      if (locale == 'hr') var countries = countriesHR;
    }

    if (this.state.loaded == false)
      return (
        <div className={classes.circularProgressRoot}>
          <CircularProgress />
        </div>
      );

    return (
      <AuthWrapper variant="bgColor" bgColor={this.state.settings.BackgroundColor}>
        <Box className={classes.authContent}>
          <GridContainer>
            {this.state.settings.Logo != null && this.state.settings.Logo != '' && (
              <Grid
                container
                xs={12}
                sm={12}
                xl={12}
                direction="row"
                alignContent="center"
                alignItems="center"
                justify="center">
                <img src={this.state.settings.Logo} style={{ maxHeight: '72px' }} />
              </Grid>
            )}
            {this.state.settings.HotelName != null && this.state.settings.Logo == '' && (
              <Grid
                container
                xs={12}
                sm={12}
                xl={12}
                direction="row"
                alignContent="center"
                alignItems="center"
                justify="center">
                {this.state.settings.HotelName}
                <br />
                {this.state.settings.HotelAddress}
                <br />
              </Grid>
            )}

            <Grid item xs={10} sm={10} xl={10}>
              <Typography component="div" variant="h1" className={classes.titleRoot}>
                Self Check-in
              </Typography>
            </Grid>
            <Grid item xs={2} sm={2} xl={2}>
              <LanguageSwitcher />
            </Grid>
          </GridContainer>
          <div></div>

          {this.state.success == 1 && (
            <Typography component="div" variant="h3" className={classes.titleRoot}>
              Uspješno poslana prijava
            </Typography>
          )}

          <form>
            {this.state.success == 0 && this.state.myReservationId == '' && (
              <Box mb={2}>
                {' '}
                <TextField
                  label=<IntlMessages id="res.id" />
                  fullWidth
                  value={this.state.reservationId}
                  margin="normal"
                  variant="outlined"
                  defaultValue=""
                  onChange={event => this.handleChange('reservationId', event.target.value)}
                  className={classes.textFieldRoot}
                />
              </Box>
            )}
            {this.state.success == 0 && this.state.myReservationId != '' && (
              <Box mb={2}>
                <Typography component="div" variant="h3" className={classes.titleRoot}>
                  <IntlMessages id="res.id" />: {this.state.myReservationId}{' '}
                  <IconButton aria-label="changeId" onClick={() => this.handleAction('changeId', 0)}>
                    <EditIcon />
                  </IconButton>
                </Typography>
                <Typography component="div" variant="h4" className={classes.titleRoot}>
                  <IntlMessages id="res.persons" /> {this.state.guestInfo.length}
                </Typography>
                <Button onClick={() => this.handleAction('addnew', 0)} variant="contained" color="primary">
                  <IntlMessages id="selfcheckin.addNew" />
                </Button>
              </Box>
            )}
            {this.state.success == 0 && this.state.message != '' && <Alert severity="error">{this.state.message}</Alert>}

            {this.state.success == 0 &&
              this.state.allow == 1 &&
              this.state.guestInfo.map((item, index) => (
                <Box mb={2}>
                  <Box className={classes.boxClass2}>
                    <Typography className={classes.titleRoot2} noWrap display="inline">
                      #{index + 1}
                    </Typography>
                    {this.state.rooms.length > 1 && (
                      <TextField
                        id="priceModel"
                        name="RoomId"
                        select
                        size="small"
                        inputProps={{ min: 0, style: { textAlign: 'center' } }}
                        margin="small"
                        variant="outlined"
                        className={classes.textFieldRoot2}
                        value={item.RoomId}
                        onChange={event => this.handleChange('RoomId', event.target.value, index)}>
                        {this.state.rooms.map((idx2, idx) => (
                          <MenuItem value={idx2}>
                            <IntlMessages id="room" /> {idx + 1}
                          </MenuItem>
                        ))}
                      </TextField>
                    )}
                    <IconButton aria-label="delete" onClick={() => this.handleAction('delete', index)}>
                      <DeleteIcon />
                    </IconButton>
                  </Box>
                  <GridContainer spacing={2}>
                    <Grid item xs={6} sm={6} xl={6}>
                      <TextField
                        label=<IntlMessages id="selfcheckin.firstName" />
                        fullWidth
                        value={item.FirstName}
                        margin="normal"
                        variant="standard"
                        defaultValue=""
                        onChange={event => this.handleChange('FirstName', event.target.value, index)}
                        className={classes.textFieldRoot}
                      />
                    </Grid>
                    <Grid item xs={6} sm={6} xl={6}>
                      <TextField
                        label=<IntlMessages id="selfcheckin.lastName" />
                        fullWidth
                        value={item.LastName}
                        margin="normal"
                        variant="standard"
                        defaultValue=""
                        onChange={event => this.handleChange('LastName', event.target.value, index)}
                        className={classes.textFieldRoot}
                      />
                    </Grid>
                    <Grid item xs={6} sm={6} xl={6}>
                      <TextField
                        label=<IntlMessages id="selfcheckin.sex" />
                        id="priceModel"
                        name="sex"
                        select
                        margin="normal"
                        fullWidth
                        className={classes.textFieldRoot}
                        value={item.Sex}
                        onChange={event => this.handleChange('Sex', event.target.value, index)}>
                        <MenuItem value="M">
                          <IntlMessages id="selfcheckin.male" />
                        </MenuItem>
                        <MenuItem value="F">
                          <IntlMessages id="selfcheckin.female" />
                        </MenuItem>
                      </TextField>
                    </Grid>
                    <Grid item xs={6} sm={6} xl={6}>
                      <TextField
                        label=<IntlMessages id="selfcheckin.citizenship" />
                        fullWidth
                        value={item.Citizenship}
                        margin="normal"
                        variant="standard"
                        defaultValue=""
                        select
                        onChange={event => this.handleChange('Citizenship', event.target.value, index)}
                        className={classes.textFieldRoot}>
                        {countries.map(t => (
                          <MenuItem value={t.code}>{t.name}</MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                    <Grid item xs={6} sm={6} xl={6}>
                      <DatePicker
                        variant="inline"
                        format="DD/MM/yyyy"
                        margin="normal"
                        id="date2"
                        name="BirthDate"
                        label=<IntlMessages id="selfcheckin.birthDate" />
                        fullWidth
                        value={item.BirthDate}
                        autoOk="true"
                        onChange={date => this.handleChange('BirthDate', getMyDate(date), index)}
                        KeyboardButtonProps={{
                          'aria-label': 'change date',
                        }}
                      />
                    </Grid>
                    <Grid item xs={6} sm={6} xl={6}>
                      <TextField
                        label=<IntlMessages id="selfcheckin.birthCountry" />
                        fullWidth
                        value={item.Country}
                        margin="normal"
                        variant="standard"
                        defaultValue=""
                        select
                        onChange={event => this.handleChange('BirthCountry', event.target.value, index)}
                        className={classes.textFieldRoot}>
                        {countries.map(t => (
                          <MenuItem value={t.code}>{t.name}</MenuItem>
                        ))}
                      </TextField>
                    </Grid>

                    <Grid item xs={6} sm={6} xl={6}>
                      <TextField
                        label=<IntlMessages id="selfcheckin.document" />
                        id="priceModel"
                        name="idType"
                        select
                        fullWidth
                        margin="normal"
                        className={classes.textFieldRoot}
                        value={item.idType}
                        onChange={event => this.handleChange('idType', event.target.value, index)}>
                        <MenuItem value="1">
                          <IntlMessages id="selfcheckin.d1" />
                        </MenuItem>
                        <MenuItem value="2">
                          <IntlMessages id="selfcheckin.d2" />
                        </MenuItem>
                        <MenuItem value="3">
                          <IntlMessages id="selfcheckin.d3" />
                        </MenuItem>
                        <MenuItem value="4">
                          <IntlMessages id="selfcheckin.d4" />
                        </MenuItem>
                        <MenuItem value="5">
                          <IntlMessages id="selfcheckin.d5" />
                        </MenuItem>
                        <MenuItem value="6">
                          <IntlMessages id="selfcheckin.d6" />
                        </MenuItem>
                      </TextField>
                    </Grid>
                    <Grid item xs={6} sm={6} xl={6}>
                      <TextField
                        label=<IntlMessages id="selfcheckin.idNumber" />
                        fullWidth
                        value={item.idNumber}
                        margin="normal"
                        variant="standard"
                        defaultValue=""
                        onChange={event => this.handleChange('idNumber', event.target.value, index)}
                        className={classes.textFieldRoot}
                      />
                    </Grid>
                    <Grid item xs={6} sm={6} xl={6}>
                      <TextField
                        label=<IntlMessages id="selfcheckin.city" />
                        fullWidth
                        value={item.City}
                        margin="normal"
                        variant="standard"
                        defaultValue=""
                        onChange={event => this.handleChange('City', event.target.value, index)}
                        className={classes.textFieldRoot}
                      />
                    </Grid>
                    <Grid item xs={6} sm={6} xl={6}>
                      <TextField
                        label=<IntlMessages id="selfcheckin.country" />
                        fullWidth
                        value={item.Country}
                        margin="normal"
                        variant="standard"
                        defaultValue=""
                        select
                        onChange={event => this.handleChange('Country', event.target.value, index)}
                        className={classes.textFieldRoot}>
                        {countries.map(t => (
                          <MenuItem value={t.code}>{t.name}</MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                  </GridContainer>
                </Box>
              ))}
          </form>

          {this.state.success == 0 && this.state.allow == 1 && (
            <Box display="flex" alignItems="center" justifyContent="space-between" mb={5}>
              <Button onClick={() => this.onSubmit()} variant="contained" color="primary" fullWidth>
                {this.state.myReservationId == '' ? (
                  <IntlMessages id="selfcheckin.start" />
                ) : (
                  <IntlMessages id="selfcheckin.finish" />
                )}
              </Button>
            </Box>
          )}

          {this.state.settings.HotelName != null && (
            <Box display="flex" alignItems="center" justifyContent="space-between" mb={5}>
              <Grid
                container
                xs={12}
                sm={12}
                xl={12}
                direction="row"
                alignContent="center"
                alignItems="center"
                justify="center">
                <p align="center">
                  {this.state.settings.HotelName}
                  <br />
                  {this.state.settings.HotelAddress}
                  <br />
                  {this.state.settings.HotelEmail} {this.state.settings.HotelEmail != '' && <>{' | '}</>}{' '}
                  {this.state.settings.HotelPhone}
                </p>
              </Grid>
            </Box>
          )}
        </Box>
      </AuthWrapper>
    );
  }
}

const mapStateToProps = state => {
  return {
    auth: state.auth,
  };
};
SelfCheckIn.contextType = AppContext;
export default withStyles(useStyles)(connect(mapStateToProps)(SelfCheckIn));
